import Checkout from './Checkout'
import AddToCart from './AddToCart'
import Close from "./Close";


function Button({ children }) {
    return (<>{children}</>);
}

Button.Checkout = Checkout;
Button.AddToCart = AddToCart;
Button.Close = Close;

export default Button;
